import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/**
 * Course (a standalone-sold video series) one-shot purchase: creator + the course
 * SLUG. The backing derived listing is resolved server-side from the slug, so —
 * unlike {@link DigitalIntentBuilder} — no `listing_id` is sent.
 */
export class CourseIntentBuilder extends StoreScopedIntentBuilder {
  slug(courseSlug: string): this {
    this.root.param('course_slug', courseSlug);
    return this;
  }
}
